import { userConstants } from '../constants';
import { userService } from '../services';
import { history, disconnectSocket } from '../helpers';
import { showToast } from '../services/toast';
import { auditLog } from '../utils/logger';
import { setFaroUserContext, clearFaroUserContext } from '../observability';

export const userActions = {
    login,
    validateopt,
    logout,
    updatePassword,
    forgotPassword
};

function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                user => {
                    dispatch(success(user));
                    auditLog('login', { username });
                    const userId = user?.data?.UserID;
                    if (userId) {
                        setFaroUserContext({
                            user_id: String(userId),
                            tenant_id: user?.data?.TenantID ?? user?.data?.tenantId
                        });
                    }
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function validateopt(username, otp) {
    return dispatch => {
        dispatch(request({ username }));

        userService.validateopt(username, otp)
            .then(
                user => {
                    dispatch(success(user));
                    const userId = user?.data?.UserID;
                    if (userId) {
                        setFaroUserContext({
                            user_id: String(userId),
                            tenant_id: user?.data?.TenantID ?? user?.data?.tenantId
                        });
                    }
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    auditLog('logout');
    clearFaroUserContext();
    disconnectSocket();
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function updatePassword(passwordDetails) {
    return dispatch => {
        return userService.updatePassword(passwordDetails)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            )
    };
}

function forgotPassword(username) {
    return dispatch => {
        return userService.forgotPassword(username)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            )
    };
}
